import { getAssetFromAddress, Asset } from 'app-lib/assetUtils'
import { abbreviate } from 'app-lib/numberUtils'
import chainConfigs from 'bzx-common/src/config/chains'
import { observer } from 'mobx-react'
import React from 'react'
import { Button, InputBasic } from 'ui-framework'
import DebugVM from './DebugVM'

const knownAddresses = Object.values(chainConfigs).reduce((acc, chain) => {
  acc[chain.contracts.bzx.toLowerCase()] = `bzxContract ${chain.chainDetails.shortName}`
  return acc
}, {} as Record<string, string>)

function SpendingApprovals({ vm }: { vm: DebugVM }) {
  const { chainId, isConnected } = vm.rootStore.web3Connection

  if (!chainId || !isConnected) {
    return null
  }

  return (
    <div>
      <div className="panel--simple padded-2 margin-top-1">
        <h3 className="flex-row-center title-section">
          Approvals
          <Button
            variant="green"
            onClick={vm.getSpendingApprovals}
            className="flex-row-end"
            isLoading={vm.approvalsPending}>
            Get Approvals
          </Button>
        </h3>

        <div className="margin-bottom-2">
          <InputBasic
            id="input-view-zero-approvals"
            type="checkbox"
            onChange={vm.set}
            onChangeEmit="name-value"
            name="viewZeroApprovals"
            value={vm.viewZeroApprovals}
          />
          <label className="margin-left-1ch txt-alternate" htmlFor="input-view-zero-approvals">
            {'View "zero" approvals'} ({vm.rootStore.spendingApprovals.list.length})
          </label>
        </div>
        <div className="overflow-x-auto">
          <table className="table table--narrow">
            <thead>
              <tr>
                <th className="table__head txt-left">Token</th>
                <th className="table__head txt-left">Token address</th>
                <th className="table__head txt-left">Spender</th>
                <th className="table__head txt-left">Amount</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {vm.spendingApprovals.map((approval) => {
                let spenderLabel = knownAddresses[approval.spender.toLowerCase()]
                if (!spenderLabel) {
                  const asset = getAssetFromAddress(chainId, approval.spender)
                  if (asset !== Asset.UNKNOWN) {
                    spenderLabel = asset
                  }
                }
                if (!spenderLabel) {
                  spenderLabel = approval.spender
                }
                return (
                  <tr key={approval.spender + approval.token}>
                    <td>{approval.token}</td>
                    <td title={approval.assetAddress}>{approval.assetAddress}</td>
                    <td title={approval.spender}>{spenderLabel}</td>
                    <td>{abbreviate(approval.amount)}</td>
                    <td>
                      <Button
                        variant="blue"
                        size="narrow"
                        onClick={vm.removeApproval}
                        onClickEmit="value"
                        value={approval}>
                        Remove
                      </Button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default observer(SpendingApprovals)
